export const BACKOFFICE_SERVICE_ENDPOINT = {
  SUPPLIER_DETAILS_WITH_PAGINATION: '/pagination/allSupplierDetails',
  ALL_SUPPLIER_DETAILS: '/allSupplierDetails',
  VALIDATE_TAX_IDENTIFIER: '/validateTaxIdentifier',
  ONBOARD_SUPPLIER: '/onboard/supplier'
};
